/**
 * Best-effort client-side JWT payload decoder. Used for UI gating only
 * (no signature verification) — every privileged path is also enforced
 * server-side by `verifyIdToken` in the Cloud Function gate and by
 * Firestore rules. Returns `null` on any malformed input.
 */
export function decodeIdTokenClaims<T = Record<string, unknown>>(
  idToken: string,
): T | null {
  const payload = idToken.split(".")[1];
  if (!payload) return null;
  try {
    const json = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(json) as T;
  } catch {
    return null;
  }
}
